import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC, useRef } from 'react'
import { useInView } from 'react-intersection-observer'
import { Container, Icon } from '@components/gassan-ui'
import { MembershipNavigationItem } from './NavigationItem'
import { useMembershipNavigation } from './hooks/use-membership-navigation'

type MembershipPageNavigationProps = {}

export const MembershipPageNavigation: FC<MembershipPageNavigationProps> = () => {
  const { asPath } = useRouter()
  const parentRef = useRef<HTMLDivElement>(null)
  const { inView: lastItemInView, ref } = useInView()
  const { t } = useTranslation('navigation')
  const { navItems, localizedNavItems, scrollToEnd } = useMembershipNavigation(parentRef)

  return (
    <section className="relative">
      <Container
        maxWidth="80rem"
        className="no-scrollbar relative flex !w-full gap-4 overflow-auto px-4 py-1 pb-[5px] sm:gap-6 xl:justify-evenly xl:gap-4"
        ref={parentRef}
      >
        {navItems.map((item) => (
          <MembershipNavigationItem
            key={item.key}
            icon={<Icon dynamicStroke={false} color="inherit" icon={item.icon} />}
            href={localizedNavItems[item.key].url}
            title={localizedNavItems[item.key].title}
            status={localizedNavItems[item.key].url === asPath ? 'active' : 'idle'}
          />
        ))}
        <div className="relative px-2">
          <span className="absolute left-[50%] top-[50%] block h-[70%] w-[1px] translate-x-[-50%] translate-y-[-50%] bg-pampas" />
        </div>
        <MembershipNavigationItem
          icon={<Icon color="inherit" icon="account-profile" />}
          href={t('account.overview.url')}
          title="Account"
          status="idle"
        />
        <div ref={ref} className="pointer-events-none h-[5px] pl-1" />
      </Container>
      <div className="mt-[-1px] h-[1px] w-full bg-pampas" />
      {!lastItemInView && (
        <button
          onClick={scrollToEnd}
          className="absolute right-0 top-[50%] flex h-[70%] translate-y-[-50%] items-center border-l border-pampas bg-white"
        >
          <Icon icon="chevron-right" size={32} />
        </button>
      )}
    </section>
  )
}
